import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

import { Controller } from 'react-hook-form'

import CommonFilterMenu from './CommonFilterMenu'

const FilterMenuField = ({ control, name, onChange = noop, ...rest }) => {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange: onChangeHookForm, value } }) => {
        const handleChange = value => {
          onChange(value)
          onChangeHookForm(value)
        }

        return <CommonFilterMenu onChange={handleChange} value={value} {...rest} />
      }}
    />
  )
}

FilterMenuField.propTypes = {
  control: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
}

export default FilterMenuField
